/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal[_ngcontent-%COMP%]{text-align:center}@media screen and (min-width:768px){.modal[_ngcontent-%COMP%]:before{display:inline-block;vertical-align:middle;content:\" \";height:100%}}.modal-dialog[_ngcontent-%COMP%]{display:inline-block;text-align:left;vertical-align:middle}\n/*# sourceMappingURL=confirm-modal.component.css.map*/"];
export { styles as styles };
